var render = function() {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [
        "" + _vm.baseClass,
        ((_obj = {}), (_obj[_vm.baseClass + "--disabled"] = _vm.disabled), _obj)
      ]
    },
    [
      _c(
        "button",
        {
          class: _vm.baseClass + "-minus",
          attrs: {
            type: "button",
            disabled: _vm.disabled || _vm.locked || _vm.quantity <= _vm.min
          },
          on: {
            click: function($event) {
              $event.preventDefault()
              return _vm.$emit("sub")
            }
          }
        },
        [_c("SVGMinus")],
        1
      ),
      _vm._v(" "),
      _c("span", {
        class: _vm.baseClass + "-value",
        domProps: { innerHTML: _vm._s(_vm.quantity) }
      }),
      _vm._v(" "),
      _c(
        "button",
        {
          class: _vm.baseClass + "-plus",
          attrs: {
            type: "button",
            disabled: _vm.disabled || _vm.locked || _vm.quantity >= _vm.max
          },
          on: {
            click: function($event) {
              $event.preventDefault()
              return _vm.$emit("add")
            }
          }
        },
        [_c("SVGPlus")],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }